module.exports = "<button \n\tclass=\"button comments-button button-block\" \n\tng-click=\"$ctrl.show()\">\n\t\t<i ng-class=\"{ 'ion-compose': !$ctrl.loading, 'fa fa-refresh fa-spin': $ctrl.loading }\" ng-if=\"!$\"></i><i class=\"\" ng-if=\"$ctrl.loading\"></i>\n\t\t<span ng-if=\"!$ctrl.loading\">{{ 'comments' | translate | ucfirst }}</span>\n\t\t<div class=\"count\" ng-if=\"$ctrl.count\">{{ $ctrl.count }}</div>\n</button>"


//////////////////
// WEBPACK FOOTER
// ./app/components/commentsButton/commentsButton.html
// module id = 395
// module chunks = 0